<template>
  <section class="p-2 bg-light rounded shadow border-start-blue mb-2">
    <h5 class="fw-bold text-primary mb-1">Parâmetros de Dados</h5>

    <b-row>
      <b-col cols="12">
        <validation-provider #default="{ errors }" name="Data Inicial" rules="required">
          <b-form-group
            label="Data Inicial para Considerar os Registros"
            label-for="data-filtro"
            :state="errors.length > 0 || form.errors.dataFiltro ? false : null"
            description="Define a partir de qual data os registros serão considerados, com base na data do gesto vacinal."
          >
            <b-form-datepicker
              id="data-filtro"
              :value="form.dataFiltro"
              @input="$emit('update:dataFiltro', $event)"
              :hide-header="true"
              placeholder="00/00/0000"
              label-help="Selecione a data"
              :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
              locale="pt-BR"
              :min="new Date(2025, 0, 1)"
              :disabled="!permiteGerenciar"
            />
            <small v-if="errors[0]" class="text-danger d-block">Este campo é de preenchimento obrigatório.</small>
            <small v-if="form.errors.dataFiltro" class="text-danger">{{ form.errors.dataFiltro }}</small>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { BRow, BCol, BFormGroup, BFormDatepicker } from 'bootstrap-vue';
import {required} from '@validations'
import { ValidationProvider } from 'vee-validate';

export default {
  name: 'ParametrosDados',
  components: { BRow, BCol, BFormGroup, BFormDatepicker, ValidationProvider },
  props: {
    form: { type: Object, required: true },
    permiteGerenciar: { type: Boolean, default: false }
  },
  data() {
    return {
      required
    }
  }
};
</script>
